module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.61cf6362.svg";